<template>
  <vx-card no-shadow>

    <vs-input class="w-full mb-base" label-placeholder="Jelenlegi jelszó" type="password" v-model="passwordChange.oldPassword" />
    <vs-input class="w-full mb-base" label-placeholder="Új jelszó" type="password" v-model="passwordChange.newPassword" />
    <vs-input class="w-full mb-base" label-placeholder="Új jelszó ismét" type="password" v-model="passwordChange.newPasswordConfirmation" />

    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center">
      <vs-button class="mt-2" @click="updatePassword()">Mentés</vs-button>
    </div>
  </vx-card>
</template>

<script>
export default {
  data() {
    return {
		old_password: "",
		new_password: "",
		confirm_new_password: "",
		passwordChange: {}
    }
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    },
  },
  methods: {
	getUser() {
		this.$http.get('/api/users/show/' + this.activeUserInfo.id)
			.then((response) => {
				this.user = response.data.data
			})
			.catch((error) => { 
				this.showError(error)
			})
	},
	updatePassword() {
		this.passwordChange.email = this.user.email
		this.$http.post('/api/users/password/change', this.passwordChange)
			.then((response) => {
				this.$vs.notify({
					title: 'Siker',
					text: response.data.message,
					iconPack: 'feather',
					icon: 'icon-alert-circle',
					color: 'success',
					position: 'bottom-center'
				})
				this.passwordChange = {}
			})
			.catch((error) => { 
				let errors = error.response.data
				let errArr = []
				let errorMessage = ''
				for (let key in errors) {
					errArr.push(errors[key][0])
					errorMessage += errors[key][0] + '<br>'

				}
				this.passwordChange = {}
				this.showError(errorMessage)
			})
	},
	showError(errorMessage) {
			this.$vs.loading.close()
			this.$vs.notify({
				time: 8000,
				title: 'Hiba',
				text: errorMessage,
				iconPack: 'feather',
				icon: 'icon-alert-circle',
				color: 'danger',
				position: 'bottom-center'
			})
		}
  },
  mounted() {
		this.getUser()
  }
}
</script>
